<template>
    <Menubar :model="items" />
</template>

<script>
import Menubar from '@/Shared/Components/Menubar';

export default {
    components: { Menubar },

    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            //
        };
    },
    methods: {
        //
    },
    mounted() {
        //
    }
}
</script>

<style lang="postcss">
.p-menubar {
    @apply p-0 border-0;
}

.p-menubar .p-menuitem-link {
    @apply text-fh-blue;
}
</style>